import { defineMessages } from 'react-intl';

export const messages: {
	ecosystemAppIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ecosystemAppIconLabel: {
		id: 'studio-trigger-solution-build-plan-card.title-icon-picker.ecosystem-app-icon-label',
		defaultMessage: 'Ecosystem App',
		description: 'Ecosystem App icon label (displayed in the card)',
	},
});
